// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PhoneNumberParent .PhoneInputCountry {
    padding: 0.75rem;
    background: var(--color-dark-background);
    height: 40px;
    margin-inline-end: 0.5rem;
    border-radius: 0.25rem;
    margin-top: 0.25rem;
}
.dark .PhoneNumberParent .PhoneInputCountry {
    background: var(--color-super-light-grey);
}

.PhoneNumberParent .PhoneInputCountrySelectArrow {
    border-color: black;
    opacity: 1;
    margin-inline-start: 0.75rem;
}
.dark .PhoneNumberParent .PhoneInputCountrySelectArrow {
    border-color: white;
}

/* 
    Setup is to controll that v1 still have marign-top as CSS imports scopes. 
    In v1 we done have PhoneNumberParent
*/

.PhoneNumberParent .PhoneInputCountry {
    margin-top: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/flow/components/custom-components/css/phoneInputCountry.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,wCAAwC;IACxC,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,4BAA4B;AAChC;AACA;IACI,mBAAmB;AACvB;;AAEA;;;CAGC;;AAED;IACI,0BAA0B;AAC9B","sourcesContent":[".PhoneNumberParent .PhoneInputCountry {\n    padding: 0.75rem;\n    background: var(--color-dark-background);\n    height: 40px;\n    margin-inline-end: 0.5rem;\n    border-radius: 0.25rem;\n    margin-top: 0.25rem;\n}\n.dark .PhoneNumberParent .PhoneInputCountry {\n    background: var(--color-super-light-grey);\n}\n\n.PhoneNumberParent .PhoneInputCountrySelectArrow {\n    border-color: black;\n    opacity: 1;\n    margin-inline-start: 0.75rem;\n}\n.dark .PhoneNumberParent .PhoneInputCountrySelectArrow {\n    border-color: white;\n}\n\n/* \n    Setup is to controll that v1 still have marign-top as CSS imports scopes. \n    In v1 we done have PhoneNumberParent\n*/\n\n.PhoneNumberParent .PhoneInputCountry {\n    margin-top: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
